// Triggers a focus of a text input from within a click event.
//
// In Mobile Safari, you're only allowed to trigger an initial input focus (i.e.
// something that opens up the keyboard to edit text) from some other user
// event, e.g. pressing a button. This causes a problem for instances like a
// modal with an input in it, where the modal might not be rendered when the
// button is pressed, so we can't trigger the focus yet.
//
// To get around this, there's a separate behavior that we can take advantage
// of: you are allowed to switch focus from focused text element to another. So,
// within the context of a valid event handler (like an onClick), we can
// generate a hidden text input and focus it. Then, when the other input is
// created, it can steal the focus from our hidden input and we then clean up
// the hidden input.
//
// Adapted from here: https://stackoverflow.com/a/55652503
export function triggerFocusFromClick() {
  // Create invisible input
  const fakeInput = document.createElement('input');
  fakeInput.setAttribute('type', 'text');
  fakeInput.style.position = 'absolute';
  fakeInput.style.opacity = '0';
  fakeInput.style.height = '0';
  fakeInput.style.fontSize = '16px';
  fakeInput.style.width = '0';

  // Remove the input when something else steals the focus
  fakeInput.addEventListener('blur', () => {
    document.body.removeChild(fakeInput);
  });

  // Add the input to the body and focus it
  document.body.prepend(fakeInput);
  fakeInput.focus({ preventScroll: true });
}
